
import React, { Component } from "react";
import {
    Box,
    Grid,
    Typography,
    Paper,
    Button,
    LinearProgress,
    Container,
    Divider,
} from "@mui/material";

import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import DownloadIcon from "@mui/icons-material/Download";
import StorageIcon from "@mui/icons-material/Storage";
import FlashOnIcon from "@mui/icons-material/FlashOn";
import SecurityIcon from "@mui/icons-material/Security";
import SpeedIcon from "@mui/icons-material/Speed";

import { ClipLoader } from "react-spinners";

class DownloadSection extends Component {
    state = {
        isDownloading: false,
        downloadProgress: 0,
    };

    handleDownload = () => {
        this.setState({
            isDownloading: true,
            downloadProgress: 0,
        });

        let progress = 0;

        const interval = setInterval(() => {
            progress += 10;

            if (progress > 100) progress = 100;

            this.setState({
                downloadProgress: progress,
            });

            if (progress === 100) {
                clearInterval(interval);

                setTimeout(() => {
                    this.setState({
                        isDownloading: false,
                        downloadProgress: 0,
                    });
                }, 500);
            }
        }, 250);
    };

    render() {
        const { isDownloading, downloadProgress } = this.state;

        return (
            <Box
                sx={{
                    position: "relative",
                    overflow: "hidden",
                    minHeight: "100vh",
                    background:
                        "radial-gradient(circle at 50% 0%, rgba(255,70,25,0.10), transparent 28%), radial-gradient(circle at 0% 45%, rgba(190,35,10,0.07), transparent 28%), linear-gradient(180deg,#050505 0%,#0A0706 45%,#030303 100%)",
                    py: { xs: 7, md: 12 },
                    color: "#fff",

                    "&:before": {
                        content: '""',
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "2px",
                        background:
                            "linear-gradient(90deg,transparent,#7d1d0b,#ff5420,#ff9a4d,#ff5420,#7d1d0b,transparent)",
                        boxShadow:
                            "0 0 25px rgba(255,84,32,0.25)",
                    },
                }}
            >

                {/* =====================================================
                    BACKGROUND FIRE GLOWS
                ====================================================== */}

                <Box
                    sx={{
                        position: "absolute",
                        width: { xs: 280, md: 550 },
                        height: { xs: 280, md: 550 },
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle,rgba(255,65,20,0.12) 0%,rgba(255,65,20,0) 70%)",
                        top: -200,
                        left: -170,
                        filter: "blur(15px)",
                        pointerEvents: "none",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        width: { xs: 300, md: 500 },
                        height: { xs: 300, md: 500 },
                        borderRadius: "50%",
                        background:
                            "radial-gradient(circle,rgba(190,35,10,0.10) 0%,rgba(190,35,10,0) 70%)",
                        bottom: -180,
                        right: -150,
                        filter: "blur(20px)",
                        pointerEvents: "none",
                    }}
                />

                <Box
                    sx={{
                        position: "absolute",
                        top: "35%",
                        right: "-100px",
                        width: 260,
                        height: 260,
                        borderRadius: "50%",
                        background:
                            "rgba(255,80,30,0.035)",
                        filter: "blur(100px)",
                        pointerEvents: "none",
                    }}
                />

                <Container
                    maxWidth="xl"
                    sx={{
                        position: "relative",
                        zIndex: 2,
                    }}
                >

                    {/* =====================================================
                        PAGE HEADER
                    ====================================================== */}

                    <Box
                        sx={{
                            textAlign: "center",
                            mb: { xs: 6, md: 9 },
                        }}
                    >

                        <Box
                            sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 1.2,
                                mb: 2,
                                px: 2,
                                py: 0.8,
                                borderRadius: "20px",
                                background:
                                    "rgba(255,84,32,0.05)",
                                border:
                                    "1px solid rgba(255,84,32,0.14)",
                            }}
                        >
                            <Box
                                sx={{
                                    width: 7,
                                    height: 7,
                                    borderRadius: "50%",
                                    background: "#ff5420",
                                    boxShadow:
                                        "0 0 12px rgba(255,84,32,0.8)",
                                }}
                            />

                            <Typography
                                sx={{
                                    color: "#ff7135",
                                    fontWeight: 900,
                                    letterSpacing: "3px",
                                    fontSize: "10px",
                                }}
                            >
                                VEX CONQUER
                            </Typography>
                        </Box>

                        <Typography
                            sx={{
                                color: "#fff",
                                fontWeight: 900,
                                fontSize: {
                                    xs: "42px",
                                    sm: "56px",
                                    md: "72px",
                                },
                                lineHeight: 0.95,
                                letterSpacing: "-3px",
                                mb: 1,
                            }}
                        >
                            ENTER THE
                        </Typography>

                        <Typography
                            sx={{
                                fontWeight: 900,
                                fontSize: {
                                    xs: "42px",
                                    sm: "56px",
                                    md: "72px",
                                },
                                lineHeight: 1,
                                letterSpacing: "-3px",
                                background:
                                    "linear-gradient(90deg,#ff4b1f,#ff9a4d,#ff5420)",
                                WebkitBackgroundClip:
                                    "text",
                                WebkitTextFillColor:
                                    "transparent",
                            }}
                        >
                            CLASSIC WORLD
                        </Typography>

                        <Box
                            sx={{
                                width: 110,
                                height: 3,
                                background:
                                    "linear-gradient(90deg,transparent,#ff5420,#ff9a4d,#ff5420,transparent)",
                                mx: "auto",
                                my: 3,
                                boxShadow:
                                    "0 0 18px rgba(255,84,32,0.25)",
                            }}
                        />

                        <Typography
                            sx={{
                                maxWidth: "720px",
                                mx: "auto",
                                color: "#858585",
                                fontSize: {
                                    xs: "14px",
                                    md: "16px",
                                },
                                lineHeight: 1.9,
                            }}
                        >
                            Download the official Vex Conquer client and
                            return to the legendary 5165 era. Classic PvP,
                            guild wars, bosses, progression and the
                            Conquer experience you remember.
                        </Typography>

                    </Box>

                    {/* =====================================================
                        SERVER INFO STRIP
                    ====================================================== */}

                    <Grid
                        container
                        spacing={1.5}
                        sx={{ mb: 5 }}
                    >

                        {[
                            ["5165", "VERSION"],
                            ["130", "LEVEL CAP"],
                            ["+9", "MAX PLUS"],
                            ["1ST", "REBORN"],
                            ["PVP", "CLASSIC"],
                            ["24/7", "SERVER"],
                        ].map(
                            ([value, label]) => (
                                <Grid
                                    item
                                    xs={6}
                                    sm={4}
                                    md={2}
                                    key={label}
                                >
                                    <Box
                                        sx={{
                                            textAlign:
                                                "center",
                                            py: 1.8,
                                            px: 1,
                                            borderRadius:
                                                "10px",
                                            background:
                                                "rgba(255,255,255,0.018)",
                                            border:
                                                "1px solid rgba(255,84,32,0.07)",
                                            transition:
                                                "all .25s ease",

                                            "&:hover":
                                                {
                                                    transform:
                                                        "translateY(-3px)",
                                                    borderColor:
                                                        "rgba(255,84,32,0.25)",
                                                    background:
                                                        "rgba(255,84,32,0.035)",
                                                },
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                color:
                                                    "#ff7135",
                                                fontSize:
                                                    "18px",
                                                fontWeight:
                                                    900,
                                            }}
                                        >
                                            {value}
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color:
                                                    "#666",
                                                fontSize:
                                                    "9px",
                                                fontWeight:
                                                    800,
                                                letterSpacing:
                                                    "1px",
                                                mt: 0.3,
                                            }}
                                        >
                                            {label}
                                        </Typography>
                                    </Box>
                                </Grid>
                            )
                        )}

                    </Grid>

                    <Grid
                        container
                        spacing={4}
                        alignItems="stretch"
                    >

                        {/* =================================================
                            LEFT SIDE
                        ================================================== */}

                        <Grid
                            item
                            xs={12}
                            lg={7}
                        >

                            {/* MAIN DOWNLOAD CARD */}

                            <Paper
                                elevation={0}
                                sx={{
                                    position:
                                        "relative",
                                    overflow:
                                        "hidden",
                                    p: {
                                        xs: 3,
                                        md: 5,
                                    },
                                    borderRadius:
                                        "18px",
                                    background:
                                        "linear-gradient(145deg,#160b08,#0c0908 65%,#130705)",
                                    border:
                                        "1px solid rgba(255,84,32,0.22)",
                                    boxShadow:
                                        "0 25px 70px rgba(0,0,0,0.55)",
                                }}
                            >

                                {/* TOP FIRE LINE */}

                                <Box
                                    sx={{
                                        position:
                                            "absolute",
                                        top: 0,
                                        left: 0,
                                        width:
                                            "100%",
                                        height:
                                            "3px",
                                        background:
                                            "linear-gradient(90deg,transparent,#8e1d0b,#ff5420,#ff9a4d,#ff5420,#8e1d0b,transparent)",
                                        boxShadow:
                                            "0 0 20px rgba(255,84,32,0.35)",
                                    }}
                                />

                                {/* DECORATIVE CIRCLE */}

                                <Box
                                    sx={{
                                        position:
                                            "absolute",
                                        width: 230,
                                        height: 230,
                                        borderRadius:
                                            "50%",
                                        border:
                                            "1px solid rgba(255,84,32,0.06)",
                                        top: -130,
                                        right: -80,
                                    }}
                                />

                                <Box
                                    sx={{
                                        position:
                                            "absolute",
                                        width: 150,
                                        height: 150,
                                        borderRadius:
                                            "50%",
                                        border:
                                            "1px solid rgba(255,154,77,0.045)",
                                        bottom: -80,
                                        left: -70,
                                    }}
                                />

                                <Grid
                                    container
                                    spacing={3}
                                    alignItems="center"
                                >

                                    <Grid
                                        item
                                        xs={12}
                                        md={8}
                                    >

                                        <Box
                                            sx={{
                                                display:
                                                    "inline-flex",
                                                alignItems:
                                                    "center",
                                                gap: 1,
                                                px: 1.5,
                                                py: 0.6,
                                                borderRadius:
                                                    "5px",
                                                background:
                                                    "rgba(255,84,32,0.06)",
                                                border:
                                                    "1px solid rgba(255,84,32,0.13)",
                                                mb: 2,
                                            }}
                                        >
                                            <FlashOnIcon
                                                sx={{
                                                    color:
                                                        "#ff7135",
                                                    fontSize:
                                                        15,
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#ff7135",
                                                    fontSize:
                                                        "9px",
                                                    fontWeight:
                                                        900,
                                                    letterSpacing:
                                                        "1.5px",
                                                }}
                                            >
                                                OFFICIAL CLIENT
                                            </Typography>
                                        </Box>

                                        <Typography
                                            sx={{
                                                color:
                                                    "#fff",
                                                fontWeight:
                                                    900,
                                                fontSize: {
                                                    xs: "30px",
                                                    md: "42px",
                                                },
                                                lineHeight:
                                                    1.05,
                                                mb: 2,
                                                letterSpacing:
                                                    "-1px",
                                            }}
                                        >
                                            DOWNLOAD
                                            <Box
                                                component="span"
                                                sx={{
                                                    display:
                                                        "block",
                                                    color:
                                                        "#ff5420",
                                                }}
                                            >
                                                VEX CLIENT
                                            </Box>
                                        </Typography>

                                        <Typography
                                            sx={{
                                                color:
                                                    "#8b817b",
                                                lineHeight:
                                                    1.8,
                                                fontSize:
                                                    "14px",
                                                maxWidth:
                                                    "580px",
                                            }}
                                        >
                                            Get the latest
                                            Vex Conquer
                                            client and
                                            prepare your
                                            warrior for
                                            battle. Built
                                            around the
                                            classic 5165
                                            experience.
                                        </Typography>

                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        md={4}
                                    >

                                        <Box
                                            sx={{
                                                display:
                                                    "flex",
                                                justifyContent:
                                                    {
                                                        xs: "flex-start",
                                                        md: "flex-end",
                                                    },
                                            }}
                                        >

                                            <Box
                                                sx={{
                                                    width: 115,
                                                    height: 115,
                                                    borderRadius:
                                                        "50%",
                                                    display:
                                                        "flex",
                                                    alignItems:
                                                        "center",
                                                    justifyContent:
                                                        "center",
                                                    background:
                                                        "radial-gradient(circle,#3b130b,#120907)",
                                                    border:
                                                        "1px solid rgba(255,84,32,0.35)",
                                                    boxShadow:
                                                        "0 0 45px rgba(255,65,20,0.13)",
                                                }}
                                            >
                                                <CloudDownloadIcon
                                                    sx={{
                                                        color:
                                                            "#ff7135",
                                                        fontSize:
                                                            55,
                                                    }}
                                                />
                                            </Box>

                                        </Box>

                                    </Grid>

                                </Grid>

                                <Divider
                                    sx={{
                                        my: 4,
                                        borderColor:
                                            "rgba(255,84,32,0.10)",
                                    }}
                                />

                                <Typography
                                    sx={{
                                        color:
                                            "#fff",
                                        fontWeight:
                                            900,
                                        fontSize:
                                            "20px",
                                        mb: 0.7,
                                    }}
                                >
                                    Main Client Download
                                </Typography>

                                <Typography
                                    sx={{
                                        color:
                                            "#777",
                                        fontSize:
                                            "13px",
                                        mb: 3,
                                    }}
                                >
                                    Download the
                                    official game
                                    client below.
                                </Typography>

                               

                                <Button
                                    fullWidth
                                    variant="contained"
                                    startIcon={
                                        <FlashOnIcon />
                                    }

                                    href="https://vexconquer.site/Vex%20Conquer%202026%20-%20Client.rar"
                                    // <-- PUT YOUR MAIN DIRECT DOWNLOAD LINK HERE

                                    target="_blank"
                                    onClick={
                                        this
                                            .handleDownload
                                    }
                                    sx={{
                                        py: 2,
                                        borderRadius:
                                            "10px",
                                        background:
                                            "linear-gradient(135deg,#ff4b1f,#c72d0d)",
                                        color:
                                            "#fff",
                                        fontWeight:
                                            900,
                                        textTransform:
                                            "uppercase",
                                        letterSpacing:
                                            "0.5px",
                                        fontSize:
                                            "15px",
                                        boxShadow:
                                            "0 10px 30px rgba(255,70,25,0.20)",
                                        transition:
                                            "all .25s ease",

                                        "&:hover":
                                            {
                                                background:
                                                    "linear-gradient(135deg,#ff7135,#e53a14)",
                                                transform:
                                                    "translateY(-2px)",
                                                boxShadow:
                                                    "0 14px 35px rgba(255,70,25,0.32)",
                                            },
                                    }}
                                >
                                    Download Client
                                </Button>

                                {isDownloading && (
                                    <Box
                                        sx={{
                                            mt: 3,
                                        }}
                                    >

                                        <Box
                                            sx={{
                                                display:
                                                    "flex",
                                                justifyContent:
                                                    "center",
                                                mb: 2,
                                            }}
                                        >
                                            <ClipLoader
                                                color="#ff5420"
                                                size={30}
                                            />
                                        </Box>

                                        <LinearProgress
                                            variant="determinate"
                                            value={
                                                downloadProgress
                                            }
                                            sx={{
                                                height: 7,
                                                borderRadius:
                                                    "10px",
                                                backgroundColor:
                                                    "#21100c",

                                                "& .MuiLinearProgress-bar":
                                                    {
                                                        background:
                                                            "linear-gradient(90deg,#a9270e,#ff5420,#ff9a4d)",
                                                        borderRadius:
                                                            "10px",
                                                    },
                                            }}
                                        />

                                        <Typography
                                            sx={{
                                                color:
                                                    "#777",
                                                textAlign:
                                                    "center",
                                                fontSize:
                                                    "11px",
                                                mt: 1,
                                            }}
                                        >
                                            Preparing
                                            download...
                                            {" "}
                                            {
                                                downloadProgress
                                            }
                                            %
                                        </Typography>

                                    </Box>
                                )}

                            </Paper>

                            {/* =================================================
                                DOWNLOAD MIRRORS
                            ================================================== */}

                            <Box
                                sx={{
                                    mt: 5,
                                }}
                            >

                                <Box
                                    sx={{
                                        display:
                                            "flex",
                                        alignItems:
                                            "center",
                                        gap: 1.5,
                                        mb: 1,
                                    }}
                                >

                                    <Box
                                        sx={{
                                            width: 30,
                                            height: 2,
                                            background:
                                                "#ff5420",
                                        }}
                                    />

                                    <Typography
                                        sx={{
                                            color:
                                                "#ff7135",
                                            fontSize:
                                                "10px",
                                            fontWeight:
                                                900,
                                            letterSpacing:
                                                "2px",
                                        }}
                                    >
                                        DOWNLOAD SOURCES
                                    </Typography>

                                </Box>

                                <Typography
                                    sx={{
                                        color:
                                            "#fff",
                                        fontWeight:
                                            900,
                                        fontSize:
                                            "25px",
                                        mb: 1,
                                    }}
                                >
                                    Download Mirrors
                                </Typography>

                                <Typography
                                    sx={{
                                        color:
                                            "#666",
                                        fontSize:
                                            "13px",
                                        mb: 3,
                                    }}
                                >
                                    Choose an
                                    available mirror
                                    if your preferred
                                    download source is
                                    slow or unavailable.
                                </Typography>

                                <Grid
                                    container
                                    spacing={2}
                                >

                                    

                                    <Grid
                                        item
                                        xs={12}
                                    >
                                        <Button
                                            fullWidth
                                            href="https://vexconquer.site/Vex%20Conquer%202026%20-%20Client.rar"
                                            // <-- PUT YOUR DIRECT DOWNLOAD LINK HERE

                                            target="_blank"
                                            startIcon={
                                                <FlashOnIcon />
                                            }
                                            sx={{
                                                py: 2,
                                                borderRadius:
                                                    "10px",
                                                background:
                                                    "linear-gradient(135deg,#ff4b1f,#c72d0d)",
                                                color:
                                                    "#fff",
                                                fontWeight:
                                                    900,
                                                textTransform:
                                                    "none",
                                                fontSize:
                                                    "14px",
                                                boxShadow:
                                                    "0 8px 25px rgba(255,70,25,0.15)",

                                                "&:hover":
                                                    {
                                                        background:
                                                            "linear-gradient(135deg,#ff7135,#e53a14)",
                                                        transform:
                                                            "translateY(-2px)",
                                                    },
                                            }}
                                        >
                                            Direct Download
                                            — Recommended
                                        </Button>
                                    </Grid>

                                    
                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                    >
                                        <Button
                                            fullWidth
                                            href="https://drive.google.com/file/d/17Rm_1jLP9Lglca4XY4M_pGzOIjLTPyIM/view"
                                            // <-- PUT YOUR GOOGLE DRIVE LINK HERE

                                            target="_blank"
                                            startIcon={
                                                <StorageIcon />
                                            }
                                            sx={{
                                                py: 2,
                                                borderRadius:
                                                    "10px",
                                                background:
                                                    "#111",
                                                border:
                                                    "1px solid rgba(255,255,255,0.07)",
                                                color:
                                                    "#bbb",
                                                textTransform:
                                                    "none",
                                                fontWeight:
                                                    800,
                                                transition:
                                                    "all .25s ease",

                                                "&:hover":
                                                    {
                                                        background:
                                                            "rgba(255,84,32,0.06)",
                                                        color:
                                                            "#ff7135",
                                                        borderColor:
                                                            "rgba(255,84,32,0.3)",
                                                        transform:
                                                            "translateY(-2px)",
                                                    },
                                            }}
                                        >
                                            Google Drive
                                        </Button>
                                    </Grid>

                                    

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                    >
                                        <Button
                                            fullWidth
                                            href="https://mega.nz/file/KvR33CyD#a9e7ICDvyRK40-mmsqf-aQ8oTMmLoNH4pwwWkCrfJTQ"
                                            // <-- PUT YOUR MEGA LINK HERE

                                            target="_blank"
                                            startIcon={
                                                <DownloadIcon />
                                            }
                                            sx={{
                                                py: 2,
                                                borderRadius:
                                                    "10px",
                                                background:
                                                    "#111",
                                                border:
                                                    "1px solid rgba(255,255,255,0.07)",
                                                color:
                                                    "#bbb",
                                                textTransform:
                                                    "none",
                                                fontWeight:
                                                    800,
                                                transition:
                                                    "all .25s ease",

                                                "&:hover":
                                                    {
                                                        background:
                                                            "rgba(255,84,32,0.06)",
                                                        color:
                                                            "#ff7135",
                                                        borderColor:
                                                            "rgba(255,84,32,0.3)",
                                                        transform:
                                                            "translateY(-2px)",
                                                    },
                                            }}
                                        >
                                            Mega Download
                                        </Button>
                                    </Grid>


                                    <Grid
                                        item
                                        xs={12}
                                    >
                                        <Button
                                            fullWidth
                                            href="https://www.mediafire.com/file/3b1qwrugnohfl29/Vex+Conquer+2026+-+Client.rar/file"
                                            // <-- PUT YOUR MEDIAFIRE LINK HERE

                                            target="_blank"
                                            startIcon={
                                                <CloudDownloadIcon />
                                            }
                                            sx={{
                                                py: 2,
                                                borderRadius:
                                                    "10px",
                                                background:
                                                    "#111",
                                                border:
                                                    "1px solid rgba(255,255,255,0.07)",
                                                color:
                                                    "#bbb",
                                                textTransform:
                                                    "none",
                                                fontWeight:
                                                    800,
                                                transition:
                                                    "all .25s ease",

                                                "&:hover":
                                                    {
                                                        background:
                                                            "rgba(255,84,32,0.06)",
                                                        color:
                                                            "#ff7135",
                                                        borderColor:
                                                            "rgba(255,84,32,0.3)",
                                                        transform:
                                                            "translateY(-2px)",
                                                    },
                                            }}
                                        >
                                            MediaFire Download
                                        </Button>
                                    </Grid>

                                </Grid>
                            </Box>

                        </Grid>

                        {/* =================================================
                            RIGHT SIDE
                        ================================================== */}

                        <Grid
                            item
                            xs={12}
                            lg={5}
                        >

                            <Paper
                                elevation={0}
                                sx={{
                                    height: "100%",
                                    minHeight: {
                                        lg: "670px",
                                    },
                                    position:
                                        "relative",
                                    overflow:
                                        "hidden",
                                    background:
                                        "linear-gradient(160deg,#150806,#0b0807 60%,#160604)",
                                    border:
                                        "1px solid rgba(255,84,32,0.20)",
                                    borderRadius:
                                        "18px",
                                    p: {
                                        xs: 3,
                                        md: 5,
                                    },
                                    boxShadow:
                                        "0 25px 70px rgba(0,0,0,0.55)",
                                }}
                            >

                                {/* TOP FIRE LINE */}

                                <Box
                                    sx={{
                                        position:
                                            "absolute",
                                        top: 0,
                                        left: 0,
                                        width:
                                            "100%",
                                        height:
                                            "3px",
                                        background:
                                            "linear-gradient(90deg,transparent,#8e1d0b,#ff5420,#ff9a4d,#ff5420,#8e1d0b,transparent)",
                                    }}
                                />

                                {/* DECORATIVE RINGS */}

                                <Box
                                    sx={{
                                        position:
                                            "absolute",
                                        width: 300,
                                        height: 300,
                                        borderRadius:
                                            "50%",
                                        border:
                                            "1px solid rgba(255,84,32,0.05)",
                                        top: -150,
                                        right: -120,
                                    }}
                                />

                                <Box
                                    sx={{
                                        position:
                                            "absolute",
                                        width: 190,
                                        height: 190,
                                        borderRadius:
                                            "50%",
                                        border:
                                            "1px solid rgba(255,154,77,0.045)",
                                        bottom: -90,
                                        left: -80,
                                    }}
                                />

                                <Box
                                    sx={{
                                        textAlign:
                                            "center",
                                        position:
                                            "relative",
                                        zIndex: 2,
                                    }}
                                >

                                    {/* DOWNLOAD ICON */}

                                    <Box
                                        sx={{
                                            width: 120,
                                            height: 120,
                                            mx: "auto",
                                            mb: 3,
                                            borderRadius:
                                                "50%",
                                            display:
                                                "flex",
                                            alignItems:
                                                "center",
                                            justifyContent:
                                                "center",
                                            background:
                                                "radial-gradient(circle,#40150c,#100807)",
                                            border:
                                                "1px solid rgba(255,84,32,0.35)",
                                            boxShadow:
                                                "0 0 50px rgba(255,65,20,0.12)",
                                        }}
                                    >
                                        <SecurityIcon
                                            sx={{
                                                fontSize:
                                                    58,
                                                color:
                                                    "#ff7135",
                                            }}
                                        />
                                    </Box>

                                    <Typography
                                        sx={{
                                            color:
                                                "#ff7135",
                                            fontWeight:
                                                900,
                                            letterSpacing:
                                                "3px",
                                            fontSize:
                                                "10px",
                                            mb: 2,
                                        }}
                                    >
                                        CLASSIC 5165
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color:
                                                "#fff",
                                            fontWeight:
                                                900,
                                            fontSize: {
                                                xs: "31px",
                                                md: "40px",
                                            },
                                            lineHeight:
                                                1.05,
                                            mb: 3,
                                            letterSpacing:
                                                "-1px",
                                        }}
                                    >
                                        YOUR JOURNEY
                                        <Box
                                            component="span"
                                            sx={{
                                                display:
                                                    "block",
                                                background:
                                                    "linear-gradient(90deg,#ff4b1f,#ff9a4d)",
                                                WebkitBackgroundClip:
                                                    "text",
                                                WebkitTextFillColor:
                                                    "transparent",
                                            }}
                                        >
                                            BEGINS HERE
                                        </Box>
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color:
                                                "#827873",
                                            lineHeight:
                                                1.9,
                                            fontSize:
                                                "13px",
                                            maxWidth:
                                                "430px",
                                            mx: "auto",
                                            mb: 4,
                                        }}
                                    >
                                        Download the
                                        client, enter
                                        the world,
                                        create your
                                        character,
                                        build your
                                        guild and make
                                        your name known
                                        throughout Vex
                                        Conquer.
                                    </Typography>

                                </Box>

                                <Divider
                                    sx={{
                                        borderColor:
                                            "rgba(255,84,32,0.10)",
                                        mb: 3,
                                    }}
                                />

                                {/* =================================================
                                    CLIENT FEATURES
                                ================================================== */}

                                <Typography
                                    sx={{
                                        color:
                                            "#fff",
                                        fontWeight:
                                            900,
                                        fontSize:
                                            "13px",
                                        letterSpacing:
                                            "1.5px",
                                        textTransform:
                                            "uppercase",
                                        mb: 2,
                                    }}
                                >
                                    Client Features
                                </Typography>

                                <Grid
                                    container
                                    spacing={1.5}
                                >

                                    {/* 5165 */}

                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2,
                                                borderRadius:
                                                    "10px",
                                                background:
                                                    "rgba(255,255,255,0.025)",
                                                border:
                                                    "1px solid rgba(255,84,32,0.08)",
                                                transition:
                                                    "all .25s ease",

                                                "&:hover":
                                                    {
                                                        borderColor:
                                                            "rgba(255,84,32,0.25)",
                                                        background:
                                                            "rgba(255,84,32,0.045)",
                                                    },
                                            }}
                                        >
                                            <SpeedIcon
                                                sx={{
                                                    color:
                                                        "#ff7135",
                                                    fontSize:
                                                        28,
                                                    mb: 0.5,
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#fff",
                                                    fontWeight:
                                                        900,
                                                    fontSize:
                                                        "15px",
                                                }}
                                            >
                                                5165
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#666",
                                                    fontSize:
                                                        "10px",
                                                }}
                                            >
                                                Classic
                                                Version
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                    {/* LEVEL */}

                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2,
                                                borderRadius:
                                                    "10px",
                                                background:
                                                    "rgba(255,255,255,0.025)",
                                                border:
                                                    "1px solid rgba(255,84,32,0.08)",
                                            }}
                                        >
                                            <FlashOnIcon
                                                sx={{
                                                    color:
                                                        "#ff7135",
                                                    fontSize:
                                                        28,
                                                    mb: 0.5,
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#fff",
                                                    fontWeight:
                                                        900,
                                                    fontSize:
                                                        "15px",
                                                }}
                                            >
                                                LEVEL 130
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#666",
                                                    fontSize:
                                                        "10px",
                                                }}
                                            >
                                                Classic Cap
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                    {/* PVP */}

                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2,
                                                borderRadius:
                                                    "10px",
                                                background:
                                                    "rgba(255,255,255,0.025)",
                                                border:
                                                    "1px solid rgba(255,84,32,0.08)",
                                            }}
                                        >
                                            <SecurityIcon
                                                sx={{
                                                    color:
                                                        "#ff7135",
                                                    fontSize:
                                                        28,
                                                    mb: 0.5,
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#fff",
                                                    fontWeight:
                                                        900,
                                                    fontSize:
                                                        "15px",
                                                }}
                                            >
                                                PVP
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#666",
                                                    fontSize:
                                                        "10px",
                                                }}
                                            >
                                                Classic
                                                Battles
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                    {/* PERFORMANCE */}

                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <Paper
                                            elevation={0}
                                            sx={{
                                                p: 2,
                                                borderRadius:
                                                    "10px",
                                                background:
                                                    "rgba(255,255,255,0.025)",
                                                border:
                                                    "1px solid rgba(255,84,32,0.08)",
                                            }}
                                        >
                                            <CloudDownloadIcon
                                                sx={{
                                                    color:
                                                        "#ff7135",
                                                    fontSize:
                                                        28,
                                                    mb: 0.5,
                                                }}
                                            />

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#fff",
                                                    fontWeight:
                                                        900,
                                                    fontSize:
                                                        "15px",
                                                }}
                                            >
                                                READY
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color:
                                                        "#666",
                                                    fontSize:
                                                        "10px",
                                                }}
                                            >
                                                Download
                                                & Play
                                            </Typography>
                                        </Paper>
                                    </Grid>

                                </Grid>

                                {/* =================================================
                                    REQUIREMENTS
                                ================================================== */}

                                <Box
                                    sx={{
                                        mt: 3,
                                        p: 2.5,
                                        borderRadius:
                                            "10px",
                                        background:
                                            "linear-gradient(135deg,rgba(255,84,32,0.07),rgba(255,84,32,0.015))",
                                        border:
                                            "1px solid rgba(255,84,32,0.12)",
                                    }}
                                >

                                    <Typography
                                        sx={{
                                            color:
                                                "#ff7135",
                                            fontWeight:
                                                900,
                                            fontSize:
                                                "10px",
                                            letterSpacing:
                                                "1.5px",
                                            mb: 1,
                                        }}
                                    >
                                        BEFORE YOU PLAY
                                    </Typography>

                                    <Typography
                                        sx={{
                                            color:
                                                "#777",
                                            fontSize:
                                                "11px",
                                            lineHeight:
                                                1.7,
                                        }}
                                    >
                                        Make sure you
                                        have enough
                                        storage space
                                        and a stable
                                        internet
                                        connection before
                                        downloading the
                                        client.
                                    </Typography>

                                </Box>

                                {/* FINAL MESSAGE */}

                                <Box
                                    sx={{
                                        mt: 3,
                                        textAlign:
                                            "center",
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            color:
                                                "#444",
                                            fontSize:
                                                "9px",
                                            letterSpacing:
                                                "2px",
                                            fontWeight:
                                                800,
                                        }}
                                    >
                                        THE CLASSIC ADVENTURE AWAITS
                                    </Typography>
                                </Box>

                            </Paper>

                        </Grid>

                    </Grid>

                    {/* =====================================================
                        BOTTOM FEATURE BAR
                    ====================================================== */}

                    <Box
                        sx={{
                            mt: 6,
                            p: {
                                xs: 3,
                                md: 4,
                            },
                            borderRadius:
                                "16px",
                            background:
                                "linear-gradient(135deg,rgba(255,84,32,0.055),rgba(255,255,255,0.012))",
                            border:
                                "1px solid rgba(255,84,32,0.10)",
                        }}
                    >

                        <Grid
                            container
                            spacing={3}
                            alignItems="center"
                        >

                            <Grid
                                item
                                xs={12}
                                md={4}
                            >
                                <Typography
                                    sx={{
                                        color:
                                            "#fff",
                                        fontWeight:
                                            900,
                                        fontSize:
                                            "17px",
                                        mb: 0.5,
                                    }}
                                >
                                    READY FOR BATTLE?
                                </Typography>

                                <Typography
                                    sx={{
                                        color:
                                            "#666",
                                        fontSize:
                                            "12px",
                                    }}
                                >
                                    Download the
                                    client and begin
                                    your Vex journey.
                                </Typography>
                            </Grid>

                            <Grid
                                item
                                xs={12}
                                md={8}
                            >

                                <Grid
                                    container
                                    spacing={1.5}
                                >

                                    {[
                                        "CLASSIC PVP",
                                        "GUILD WARS",
                                        "BOSSES",
                                        "QUESTS",
                                        "CPS SYSTEM",
                                        "CLASSIC PROGRESSION",
                                    ].map(
                                        (feature) => (
                                            <Grid
                                                item
                                                xs={6}
                                                sm={4}
                                                key={
                                                    feature
                                                }
                                            >
                                                <Box
                                                    sx={{
                                                        textAlign:
                                                            "center",
                                                        py: 1,
                                                        borderRadius:
                                                            "7px",
                                                        background:
                                                            "rgba(255,255,255,0.018)",
                                                        border:
                                                            "1px solid rgba(255,255,255,0.04)",
                                                        color:
                                                            "#777",
                                                        fontSize:
                                                            "9px",
                                                        fontWeight:
                                                            800,
                                                        letterSpacing:
                                                            "0.7px",
                                                        transition:
                                                            "all .2s ease",

                                                        "&:hover":
                                                            {
                                                                color:
                                                                    "#ff7135",
                                                                borderColor:
                                                                    "rgba(255,84,32,0.18)",
                                                            },
                                                    }}
                                                >
                                                    {
                                                        feature
                                                    }
                                                </Box>
                                            </Grid>
                                        )
                                    )}

                                </Grid>

                            </Grid>

                        </Grid>

                    </Box>

                    {/* =====================================================
                        FOOTER NOTE
                    ====================================================== */}

                    <Box
                        sx={{
                            mt: 5,
                            textAlign:
                                "center",
                        }}
                    >
                        <Typography
                            sx={{
                                color:
                                    "#3f3f3f",
                                fontSize:
                                    "10px",
                                letterSpacing:
                                    "1.5px",
                                textTransform:
                                    "uppercase",
                            }}
                        >
                            Vex Conquer • Classic 5165 • Enter the World
                        </Typography>
                    </Box>

                </Container>
            </Box>
        );
    }
}

export default DownloadSection;

